import React from "react"
import { Link } from "react-router-dom"

const UserLink = () => ( 
  <div className="menu-button">
    <Link className="users" to="/settings/users">Users</Link>
  </div>
)

export default UserLink